import { useMemo } from 'react'
import { toast } from 'sonner'
import { ActionDropdown } from '@shared/components/ui/action-dropdown/ActionDropdown'
import { Button } from '@shared/components/ui/button'
import { getInvoicePanelActions } from '@shared/lib/actions/invoice-actions'
import type { InvoiceInfo } from '../../invoices/types'
import type { TableAction } from '@shared/types/data-table'

const actions = getInvoicePanelActions({}) as unknown as TableAction<InvoiceInfo>[]

interface InvoiceActionsProps {
  entityInfo: InvoiceInfo
}

export function InvoiceActionsComponent({ entityInfo }: InvoiceActionsProps) {
  const primaryCTA = useMemo(() => {
    const status = entityInfo.status
    if (status === 'draft') return { label: 'Send invoice', key: 'sendInvoice' }
    if (status === 'sent' || status === 'overdue') return { label: 'Record payment', key: 'recordPayment' }
    return null
  }, [entityInfo.status])

  return (
    <div className="flex items-center gap-2">
      {primaryCTA && (
        <Button
          variant="action"
          size="action"
          onClick={() => toast.info(`${primaryCTA.label} for invoice`)}
        >
          {primaryCTA.label}
        </Button>
      )}
      <ActionDropdown actions={actions} item={entityInfo} variant="outline" />
    </div>
  )
}
